export default __webpack_public_path__ + "static/media/youtubeClone.503a4b13.png";